import { isCompoundV3Type } from '@1delta/lender-registry'
import type { TermAdapter } from './index'

/**
 * Compound V3 (Comet) — one borrowable BASE asset per deployment, with every
 * other row being collateral-only.
 *
 * That asymmetry is structural, not a config quirk: a collateral row has no
 * borrow side and earns nothing, so it must render as `role: 'collateral'`
 * with `borrow` absent rather than as a zero-rate market.
 */
export const compoundV3Adapter: TermAdapter = {
  id: 'compound-v3',
  matches: isCompoundV3Type,
  profileId: () => 'pool.variable@v1',
  build: (input) => {
    // The base asset is the only row with a real borrow side.
    const isBase = (input.totalDebt ?? 0) > 0 || input.borrowingEnabled === true
    if (isBase) return {}
    return {
      supply: {
        role: 'collateral',
        rate: { kind: 'none', apr: 0, aprTotal: 0, isLocked: false },
        // Collateral earns nothing in Comet and cannot be lent out.
        exit: { mode: 'instant', settlement: 'sync', partialAllowed: true },
      },
      // Explicitly no borrow side on a collateral row.
      borrow: undefined,
    }
  },
}
